import React,{useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import Customer from "../../api/Customer";
import "../Inventory/createInventory.css";

function  EditCustomer() {
  const history = useHistory();
  const [customerName,SetCustomerName] = useState("");
  const [customerID,SetCustomerID] = useState("");
  const [emailID,SetEmailID] = useState("");
  const [mobNo,SetMobNo] = useState("");
  const [pass,SetPass] = useState("");
  const [billAddress,SetBillAddress] = useState("");
  const [cityName,SetCityName] = useState("");
  const [companyName,SetCompanyName] = useState("");
  const [gstNo,SetGstNo] = useState("");
    
  const params = useParams();

  useEffect(()=>{
    const HandelGetReq= async ()=>{
        // console.log(params.id)
        const res = await Customer.get(`/get-customer/${params.id}`);
        SetCustomerName( res.data.cName);
        SetCustomerID( res.data.cID);
        SetEmailID(res.data.email);
        SetMobNo(res.data.mob);
        SetPass(res.data.password);
        SetBillAddress(res.data.address);
        SetCityName(res.data.city);
        SetCompanyName(res.data.company);
        SetGstNo(res.data.gst);
    }
    HandelGetReq();
  },[SetCustomerName,SetCustomerID,SetEmailID,SetMobNo,SetPass,SetBillAddress,SetCityName,SetCompanyName,SetGstNo,params.id]);


  const {
    handleSubmit,
  } = useForm();
  const onSubmit = async() =>{
    const formdata = {
        "cName":customerName,
        "cID":customerID,
        "email":emailID,
        "mob":mobNo,
        "password":pass,
        "address":billAddress,
        "city":cityName,
        "company":companyName,
        "gst":gstNo 
    }
    window.location.href="/view-customer"
    // eslint-disable-next-line
   const res = await Customer.patch(`/update-customer/${params.id}`,formdata);
  }

  const onClickHandle = () => {
    history.push("/view-customer");
  }

  return (
    <div className='main-sec'>
    <div className="upd_section">
    <h3 className='fidoh3'>Edit Customer</h3>
    <button className='view-customer-btn' onClick={onClickHandle}>View Customer</button>
      <form className='customer-form' onSubmit ={handleSubmit(onSubmit)} >
      <div className='row'>
      <div className='colm'>
      <br/><label className='inv-labels'>Customer Name</label><br/>
          <input 
          className='input-box'
          type = "string"
          name="date"
          value={customerName}
          onChange={(e) => {
            SetCustomerName(e.target.value);
          }}
          />
        </div>
        <div className='colm'>
          <br/><label className='inv-labels'>Customer ID</label><br/>
          <input 
          className='input-box'
          type = "string"
          name="date"
          value={customerID}
          onChange={(e) => {
            SetCustomerID(e.target.value);
          }}
          />
        </div>
        </div>

        <div className='row'>
      <div className='colm'>
      <br/><label className='inv-labels'>Email</label><br/>
          <input 
          className='input-box'
          type = "string"
          name="date"
          value={emailID}
          onChange={(e) => {
            SetEmailID(e.target.value);
          }}
          />
        </div>
        
        <div className='colm'>
        <br/><label className='inv-labels'>Mobile</label><br/>
          <input 
          className='input-box'
          type ="number"
          name ="deptName"
          value = {mobNo}
          onChange={(e)=>{
            SetMobNo(e.target.value);
          }}
          />
        </div>
        </div>

        <div className='row'>
      <div className='colm'>
      <br/><label className='inv-labels'>Password</label><br/>
        <input 
          className='input-box'
          type ="number"
          name ="deptName"
          value = {pass}
          onChange={(e)=>{
            SetPass(e.target.value);
          }}
          />
        </div>

        <div className='colm'>
        <br/><label className='inv-labels'>Billing Address</label><br/>
        <input 
          className='input-box'
          type ="string"
          name ="deptName"
          value = {billAddress}
          onChange={(e)=>{
            SetBillAddress(e.target.value);
          }}
          />
        </div>
        </div>

        <div className='row'>
      <div className='colm'>
      <br/><label className='inv-labels'>City</label><br/>
        <input 
          className='input-box'
          type ="string"
          name ="deptName"
          value = {cityName}
          onChange={(e)=>{
            SetCityName(e.target.value);
          }}
          />
        </div>

        <div className='colm'>
        <br/><label className='inv-labels'>Company Name</label><br/>
        <input 
          className='input-box'
          type ="string"
          name ="deptName"
          value = {companyName}
          onChange={(e)=>{
            SetCompanyName(e.target.value);
          }}
          />
        </div>
        </div>

        <div>
        <br/><label className='inv-labels'>GST Number</label><br/>
        <input 
          className='input-box'
          type ="string"
          name ="deptName"
          value = {gstNo}
          onChange={(e)=>{
            SetGstNo(e.target.value);
          }}
          />
        </div><br/>
        
        <input className ="subButton" type="submit" value="Submit"/>
        <input className ="cancelButton" type="button" onClick={() => {history.push("/view-customer")}} value="Cancel"/>
      </form>
    </div>
    </div>
  )
}

export default EditCustomer;    